export default __webpack_public_path__ + "static/media/shin.d2c81c23.png";